import { logger } from '@accedo/logger';
import { LiveCarouselItem } from '##/components/LiveCarousel/types';
import { StandardCarouselItem } from '##/components/StandardCarousel/types';
import { isLoggedIn } from '##/services/authentication/Authentication';
import { LiveChannel } from '##/services/tenApi/collections/types';
import TealiumBridge from '##/services/analytics/Tealium/TealiumBridge';
import { CONTINUE_WATCHING_ID } from '##/utils';
import { PageNavigation } from './PageNavigation';

export const handleVideoClick = (
  tileData: StandardCarouselItem | LiveCarouselItem | LiveChannel,
  replaceRoute = false,
  withLoadingRoute = false,
): void => {
  const tileDataAsCarouselItem = tileData as StandardCarouselItem;
  const tileDataAsLiveItem = tileData as LiveChannel | LiveCarouselItem;

  if (tileDataAsCarouselItem.carouselId === CONTINUE_WATCHING_ID) {
    // eslint-disable-next-line no-param-reassign
    (tileData as StandardCarouselItem).carouselTitle = 'Continue watching';
  }

  const memberGated =
    tileDataAsCarouselItem?.memberGated || tileDataAsLiveItem?.isMemberGated;

  TealiumBridge.onCarouselItemClick(tileData);

  if (memberGated && !isLoggedIn()) {
    PageNavigation.navigateTo('/sign-in', tileData);
  } else if (
    (tileData as LiveChannel).key ||
    (tileData as LiveCarouselItem).name
  ) {
    const channelId =
      (tileData as LiveChannel).key || (tileData as LiveCarouselItem).name;
    if (withLoadingRoute) {
      PageNavigation.replaceRoute('/loading', {
        tileData,
        nextRoute: `/player/live/${channelId}`,
      });

      return;
    }

    replaceRoute
      ? PageNavigation.replaceRoute(`/player/live/${channelId}`, tileData)
      : PageNavigation.navigateTo(`/player/live/${channelId}`, tileData);
  } else if ((tileData as StandardCarouselItem).playbackApiEndpoint) {
    replaceRoute
      ? PageNavigation.replaceRoute(`/player/vod/${tileData.id}`, tileData)
      : PageNavigation.navigateTo(`/player/vod/${tileData.id}`, tileData);
  } else {
    logger.warn('No navigation information on tile, doing nothing');
  }
};
